import { getFormatterNudgeAmount, doFormatterIncrementBy, doFormatterClamp } from '../formatter/formatter.utils.js';
import { clamp } from '../utils/math.js';
import { CURSOR_MAX_WIDTH, CURSOR_MIN_WIDTH, MAX_SCALE } from './scrubbable.constants.js';

/**
 * Increments the start value by delta + movement, handling negative nudge values, and clamping
 * scrub movement so that scrubbing past the min/max doesn't accumulate a delta and scrubbing
 * back the other way changes the value instantly.
 */
function increment(formatter, start, movement, delta, big) {
    // Scrubbing always uses the small nudge amount, but snaps based on big or small nudge.
    const nudge = getFormatterNudgeAmount(formatter, false, start);
    const inc = (delta.current = delta.current + movement) * nudge;
    const newValue = doFormatterIncrementBy(formatter, start, inc, { snap: true, big });
    if (typeof start === 'number') {
        const tmp = start + inc;
        const clamped = doFormatterClamp(formatter, tmp);
        const diff = tmp - clamped;
        if (diff) {
            delta.current -= diff / nudge;
        }
    }
    return newValue;
}
function scaleForScrubEvent(e) {
    // Wheel events only have a single dimension, so we use a constant scale.
    if (e.source === 'wheel')
        return [1, 1];
    const d = distanceMultiplier(relativeDistance(e.delta.y));
    const scale = d > 0 ? d : 1 / -d;
    return [scale, d];
}
function cursorWidthForMultiplier(mult) {
    // square the multiplier to bring the curve down for a mult of 1
    const m = ((MAX_SCALE + mult) / (MAX_SCALE * 2)) ** 2;
    return Math.round((CURSOR_MAX_WIDTH - CURSOR_MIN_WIDTH) * m + CURSOR_MIN_WIDTH);
}
/** Return a number in the range [-1, 1] representing distance relative to window height. */
function relativeDistance(distance) {
    const windowHeight = window.innerHeight;
    const d = distance / windowHeight;
    return clamp(d, -1, 1);
}
/** Turn a relative distance (-1 to 1) into a multiplier for the scrub scale. */
function distanceMultiplier(reldist) {
    return reldist < -0.5
        ? MAX_SCALE
        : reldist < -0.25
            ? MAX_SCALE / 2
            : reldist < -0.125
                ? MAX_SCALE / 4
                : reldist > 0.5
                    ? -MAX_SCALE
                    : reldist > 0.25
                        ? -4
                        : reldist > 0.125
                            ? -2
                            : 1;
}

export { cursorWidthForMultiplier, increment, scaleForScrubEvent };
//# sourceMappingURL=scrubbable.utils.js.map
